import React, { memo, useEffect, useMemo } from 'react';

import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';

import { CounselingFormat, HomeBuyerCounseling } from 'constants/loanApplication';

import { pagesPropTypes } from '../../../MainContent.constants';

import { getConfig } from './Counseling.config';
import { normalizeForm } from './Counseling.utils';

const Counseling = ({
  changedFields,
  isLoading,
  isSaving,
  form,
  validationErrors,
  validateField,
  handleChange,
  entityId,
  setEntityConfig,
  setForm,
  setInForm,
  pendingChanges,
  disabledPendingChangesHighlight,
}) => {
  const sectionForm = form[entityId]?.declarations?.homeCounseling ?? {};

  const { homeBuyerCounseling, counselingFormat } = sectionForm;

  const isHomeBuyerOther = homeBuyerCounseling?.value === HomeBuyerCounseling.OTHER;
  const isCounselingOther = counselingFormat?.value === CounselingFormat.OTHER;

  const config = useMemo(
    () =>
      getConfig({
        entityId,
        isHomeBuyerOther,
        isCounselingOther,
      }),
    [entityId, isHomeBuyerOther, isCounselingOther],
  );

  useEffect(() => {
    setForm(form => normalizeForm({ form, entityId }));
  }, [config, entityId, setForm]);

  useEffect(() => {
    if (!config) {
      return;
    }

    setEntityConfig(config);
  }, [config, setEntityConfig]);

  return (
    <FormGenerator
      isNestedForm
      changedFields={changedFields}
      config={config}
      disabledPendingChangesHighlight={disabledPendingChangesHighlight}
      form={form}
      formName={FormNames.DECLARATIONS}
      handleChange={handleChange}
      isLoading={isSaving || isLoading}
      numberOfColumns={1}
      pendingChanges={pendingChanges}
      setInForm={setInForm}
      validateField={validateField}
      validationErrors={validationErrors}
    />
  );
};

Counseling.propTypes = pagesPropTypes;

export default memo(Counseling);
